import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import translate from '../../commonComponents/translate';

/**
 * Error page, used to either display errors thrown on the server
 * or caught by the ErrorBoundary on the site's main component
 */
function Error(props) {
  const {
    t,
    theme,
    status: paramStatus,
    error: paramError,
    isProduction,
  } = props;
  const status = paramStatus || 404;
  const error = paramError || { message: '', stack: '' };

  return (
    <div
      className="m-grid__item m-grid__item--fluid m-grid  m-error-1"
      style={{
        height: '100vh',
        backgroundImage: `url("/dist/${theme}/assets/app/media/img/error/bg1.jpg")`,
      }}
    >
      <div className="m-error_container">
        <span className="m-error_number">
          <h1>{status}</h1>
        </span>
        <div className="m-error_desc">
          {t(`${status}error-text-1`)}
          <br />
          <a href="/">{t(`${status}error-link`)}</a>
          {!isProduction && (
            <div style={{ paddingTop: '10px', color: '#3a3a3a' }}>
              <p>{error.message}</p>
              <p style={{ whiteSpace: 'pre-wrap' }}>{error.stack}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

Error.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  /** Metronic theme */
  theme: PropTypes.string.isRequired,
  /** Error status code */
  status: PropTypes.number,
  /** Error info to display, the error message and a stack trace */
  error: PropTypes.shape({
    message: PropTypes.string,
    stack: PropTypes.string,
  }),
  /** Whether we are in a production environment, which restricts detailed message displayed */
  isProduction: PropTypes.bool.isRequired,
};

Error.defaultProps = {
  status: null,
  error: null,
};

export default translate(Error);
